import { type FC } from 'react';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import styles from './TravelSearchResults.module.css';
import ListItemExtended from './ListItemExtended';
import { SearchResultsByLocationType } from 'types/types';
import { results_found } from 'data/translationKeys';

import Container from 'components/container';
import { Body } from 'components/text';
import Divider from 'components/divider';
interface ISearchResults {
  searchResults: SearchResultsByLocationType[];
}

const TravelSearchResults: FC<ISearchResults> = ({ searchResults }) => {
  const results_found_text = useLocalised(results_found);

  return (
    <Container mt={35} mb={70} className={styles.container}>
      <Body mb={15}>{`${searchResults.length} ${results_found_text}`}</Body>
      {searchResults.map((result, index) => (
        <Container key={index} className={styles.resultsContainer}>
          <ListItemExtended searchResults={result} />
          {index !== searchResults.length - 1 && (
            <Divider color="gold-dark" mt={30} mb={30} />
          )}
        </Container>
      ))}
    </Container>
  );
};

export default TravelSearchResults;
